import { getCurrencySymbol } from 'src/utils/misc';

const scenarioStatusOpen = `This risk is active and is effecting the organisation. It is currently subject to monitoring and action, and its value contributes to the total Expected Loss.`;
const scenarioStatusDraft = `This risk has been identified but is still being assessed and documented. It does not contribute to the total Expected Loss (to do this the risk must be Open).`;
const scenarioStatusClosed = `This risk has been permanently resolved, eliminated, or retired. The associated threat is no longer a concern or has been fully mitigated. It does not contribute to the total Expected Loss (to do this the risk must be Open).`;

const controlStrategyTransfer = `The control's purpose is to shift the financial consequences of the risk to a third party (e.g., by purchasing insurance).`;
const controlStrategyTreat = `The control's purpose is to reduce the likelihood and/or impact of this risk to an acceptable level.`;
const controlStrategyTolerate = `The control's purpose is to accept the potential consequences of this risk i.e. the risk will not be mitigated or reduced.`;
const controlStrategyTerminate = `The control is no longer required to mitigate a risk.`;

const controlStatusNotStarted = `The control has been identified but design or implementation activities have not yet commenced.`;
const controlStatusInProgress = `The control is currently being designed, documented, or rolled out across the environment.`;
const controlStatusLive = `The control is fully implemented, operational, and actively mitigating risk as intended.`;
const controlStatusAbandoned = `The control was previously planned or partially implemented but has been intentionally discarded.`;
const controlStatusRetired = `The control was previously active but has been decommissioned, likely replaced by a new process or tool.`;
const controlStatusNotApplicable = `This control is not relevant to the specific scope, business unit, or regulatory requirement.`;

export const LABELS = {
  expectedLoss: `The Expected Loss is the average amount of ${getCurrencySymbol()}s you can expect to lose over one year.`,
  // SCENARIO STATUS
  scenarioStatusOpen,
  scenarioStatusDraft,
  scenarioStatusClosed,
  scenarioStatus: `Open: ${scenarioStatusOpen}\n
Draft: ${scenarioStatusDraft}\n
Closed: ${scenarioStatusClosed}`,
  // CONTROL STRATEGY
  controlStrategyTransfer,
  controlStrategyTreat,
  controlStrategyTolerate,
  controlStrategyTerminate,
  controlStrategy: `Transfer: ${controlStrategyTransfer}\n
Treat: ${controlStrategyTreat}\n
Tolerate: ${controlStrategyTolerate}\n
Terminate: ${controlStrategyTerminate}`,
  // CONTROL STATUS
  controlStatusNotStarted,
  controlStatusInProgress,
  controlStatusLive,
  controlStatusAbandoned,
  controlStatusRetired,
  controlStatusNotApplicable,
  controlStatus: `Not Started: ${controlStatusNotStarted}\n
In Progress: ${controlStatusInProgress}\n
Live: ${controlStatusLive}\n
Abandoned: ${controlStatusAbandoned}\n
Retired: ${controlStatusRetired}\n
Not Applicable: ${controlStatusNotApplicable}`,
  // MODIFIER
  modifierBaseConsequence: `The estimated consequence (impact) or cost of the risk event before any controls or mitigating actions (modifiers) have been applied. This represents the raw, untreated risk level (Inherent Risk).`,
  modifierConsequenceImpact: `The resultant consequence (impact) after this modifier has been applied to the risk.`,
  modifierFrequencyImpact: `The resultant frequency (likelihood) after this modifier has been applied to the risk.`,
  modifierCumulativeImpact: `The resultant consequence (impact) after this modifier and all other modifiers has been applied to this risk.`,
  modifierFrequencyCumulativeImpact: `The resultant frequency (likelihood) after this modifier and all other modifiers has been applied to this risk.`,
  // RISK
  riskLive: `Expected Loss with control modifiers from live controls applied`,
  riskBase: `Expected Loss without control modifiers applied`,
  riskComplete: `Expected Loss with control modifiers from all controls applied`,
};
